module.exports = __webpack_public_path__ + "img/메인우측배너.aac28614.png";